module.exports = __webpack_public_path__ + "static/banner-image-1-9ee293ac8ac40acad64c39f4807387aa.png";